import swedish from '../assests/i18n/swe.json';
import english from '../assests/i18n/en.json';

export const SITE_URL = 'https://www.thas-multitech.com';

const translated = (swe, en) => ({ swe, en });
const service = (id, name, title, description, image) => ({
  id, paths: { swe: `/${id}`, en: `/${id}` }, type: 'service', name, title, description,
  ...(image ? { image } : {}),
});

// Keep existing article URLs stable: the site has always used the first four title words.
export const slugifyBlogTitle = (title) => title.split(' ').slice(0, 4).join(' ')
  .toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-');

const article = (number, title, description) => ({
  id: `blog-${number}`,
  paths: {
    swe: `/blogg/${slugifyBlogTitle(swedish.translation[`title${number}`])}`,
    en: `/blogg/${slugifyBlogTitle(english.translation[`title${number}`])}`,
  },
  name: translated(swedish.translation[`title${number}`], english.translation[`title${number}`]),
  image: `/images/${['blog-app-development', 'blog-web-development', 'blog-logo-design'][number - 1]}.jpeg`,
  type: 'article', title, description,
});

export const pages = [
  {
    id: 'home', paths: { swe: '/', en: '/' }, type: 'home',
    name: translated('Hem', 'Home'),
    title: translated('Teknik, design & 3D-printing i Stockholm | THAS Multitech', 'Engineering, Design & 3D Printing | THAS Multitech'),
    description: translated(
      'THAS Multitech i Stockholm hjälper dig med webbutveckling, elektronik, CAD och 3D-printing. Berätta om ditt projekt och be om en offert.',
      'THAS Multitech in Stockholm helps with web development, electronics, CAD design and 3D printing. Tell us about your project and request a quote.',
    ),
  },
  service('3d-printing', translated('3D-printing', '3D printing'),
    translated('3D-printing & prototyper i Stockholm | THAS Multitech', '3D Printing & Prototypes in Stockholm | THAS Multitech'),
    translated(
      'Behöver du en prototyp, en kapsling eller en anpassad detalj? THAS Multitech hjälper dig med 3D-printing och design. Skicka din idé och be om offert.',
      'Explore 3D printing for prototypes, enclosures and custom parts with THAS Multitech. Get design support, ask a question or request a project quote.',
    ), '/images/3d-printing-workshop.webp'),
  service('web-development', translated('Webbutveckling', 'Web development'),
    translated('Webbutveckling i Stockholm | THAS Multitech', 'Web Development in Stockholm | THAS Multitech'),
    translated(
      'En webbplats anpassad efter ditt företag. THAS Multitech hjälper dig med design, utveckling och förbättringar av befintliga webbplatser. Be om offert.',
      'Build a website around your business with THAS Multitech. Get help with web design, development or improvements to your existing site. Request a quote.',
    )),
  service('app-development', translated('Apputveckling', 'App development'),
    translated('Apputveckling i Stockholm | THAS Multitech', 'App Development in Stockholm | THAS Multitech'),
    translated(
      'Från idé till användbar app. THAS Multitech hjälper dig att planera, designa och utveckla mobilappar och webbappar. Berätta om ditt projekt.',
      'Turn your idea into a useful application. THAS Multitech helps plan, design and develop mobile and web apps. Tell us your needs and request a quote.',
    )),
  service('embedded-programming', translated('Programmering av inbyggda system', 'Embedded programming'),
    translated('Programmering av inbyggda system | THAS Multitech', 'Embedded Systems Programming | THAS Multitech'),
    translated(
      'Behöver du hjälp med ett inbyggt system? THAS Multitech utvecklar lösningar och förbättrar befintlig programvara. Kontakta oss om ditt projekt.',
      'Get support with embedded systems programming at THAS Multitech. Discuss a new development project or improvements to an existing system.',
    )),
  service('circuit-design', translated('Elektronikkonstruktion', 'Circuit design'),
    translated('Elektronikkonstruktion & kretsdesign | THAS Multitech', 'Electronic Circuit Design | THAS Multitech'),
    translated(
      'THAS Multitech hjälper dig med kretsdesign, felsökning, mätning och simulering av elektronik. Beskriv dina krav så diskuterar vi en lösning.',
      'THAS Multitech helps with custom circuit design, troubleshooting, measurement and simulation. Share your electronics project and request a quote.',
    )),
  service('pcb-design', translated('PCB-design', 'PCB design'),
    translated('PCB-design & kretskortslayout | THAS Multitech', 'PCB Design & Circuit Board Layout | THAS Multitech'),
    translated(
      'Från kretsschema till kretskortslayout. THAS Multitech hjälper dig med PCB-design utifrån ditt underlag eller ett nytt schema. Be om offert.',
      'Develop a PCB layout from your schematic with THAS Multitech. Discuss circuit board design for new or existing electronics and request a quote.',
    )),
  service('cad-design', translated('CAD-design', 'CAD design'),
    translated('CAD-design & 3D-modellering i Stockholm | THAS Multitech', 'CAD Design & 3D Modelling in Stockholm | THAS Multitech'),
    translated(
      'Visualisera din idé med CAD-design och 3D-modellering. THAS Multitech hjälper dig med mekaniska detaljer och modeller. Berätta vad du vill skapa.',
      'Visualise your idea with CAD design and 3D modelling from THAS Multitech. Discuss mechanical parts, product models and the design support you need.',
    )),
  service('graphic-design', translated('Grafisk design', 'Graphic design'),
    translated('Grafisk design i Stockholm | THAS Multitech', 'Graphic Design in Stockholm | THAS Multitech'),
    translated(
      'Grafisk design som gör ditt budskap tydligt. THAS Multitech hjälper dig med broschyrer, banners och visuellt material. Kontakta oss för en offert.',
      'Communicate your message with graphic design from THAS Multitech. Get help with brochures, banners and visual materials. Tell us about your project.',
    )),
  service('logo-design', translated('Logotypdesign', 'Logo design'),
    translated('Logotypdesign för ditt företag | THAS Multitech', 'Logo Design for Your Business | THAS Multitech'),
    translated(
      'En logotyp som speglar ditt företag. THAS Multitech hjälper dig att utveckla en visuell identitet utifrån dina idéer och behov. Be om offert.',
      'Create a logo that reflects your business. THAS Multitech develops logo designs around your ideas and brand identity. Get in touch for a quote.',
    )),
  service('advertisement', translated('Annonsering i sociala medier', 'Social media advertising'),
    translated('Design & annonsering i sociala medier | THAS Multitech', 'Social Media Design & Advertising | THAS Multitech'),
    translated(
      'Få hjälp med grafiska inlägg, videoredigering och publicering i sociala medier. THAS Multitech planerar innehåll med dig utifrån företagets behov.',
      'Get help with social media graphics, video editing and publishing. THAS Multitech works with you to plan content around your business needs.',
    )),
  {
    id: 'work-with-us', paths: { swe: '/work-with-us', en: '/work-with-us' }, type: 'page',
    name: translated('Samarbeta med oss', 'Work with us'),
    title: translated('Samarbeta med oss | THAS Multitech', 'Work with Us | THAS Multitech'),
    description: translated(
      'Har du ett projekt eller en kontakt som passar THAS Multitech? Vi välkomnar samarbeten inom teknik, design och utveckling. Hör av dig med din idé.',
      'Have a project or a connection that fits THAS Multitech? Explore collaboration in engineering, design and development. Get in touch with your idea.',
    ),
  },
  {
    id: 'blogg', paths: { swe: '/blogg', en: '/blogg' }, type: 'collection',
    name: translated('Kunskap & inspiration', 'Insights & inspiration'),
    title: translated('Artiklar om utveckling & design | THAS Multitech', 'Development & Design Articles | THAS Multitech'),
    description: translated(
      'Läs artiklar från THAS Multitech om apputveckling, webbutveckling och logotypdesign. Hitta inspiration och lär känna våra arbetssätt.',
      'Read THAS Multitech articles on app development, web development and logo design. Find inspiration and learn about our approach to your project.',
    ),
  },
  article(1,
    translated('Från idé till app: vår apputveckling | THAS Multitech', 'From Idea to App: Our Development Approach | THAS Multitech'),
    translated(
      'Läs om hur THAS Multitech arbetar med apputveckling, användarupplevelse och underhåll för att hjälpa dig vidare med din appidé.',
      'Explore the THAS Multitech approach to app development, user experience and ongoing support, and discover how to take your app idea forward.',
    )),
  article(2,
    translated('Webbutveckling för ditt företag | THAS Multitech', 'Web Development for Your Business | THAS Multitech'),
    translated(
      'Utforska THAS Multitechs arbete med webbplatser, responsiv design och webbappar. Läs om stegen mot en digital närvaro för ditt företag.',
      'Explore THAS Multitech website development, responsive design and web applications. Learn about building an online presence for your business.',
    )),
  article(3,
    translated('Från idé till logotyp: vår designprocess | THAS Multitech', 'From Idea to Logo: Our Design Process | THAS Multitech'),
    translated(
      'Följ THAS Multitechs process för logotypdesign, från att förstå ditt företag till idéer, skisser och en färdig logotyp som speglar ditt varumärke.',
      'Follow the THAS Multitech logo design process, from understanding your business to ideas, sketches and a finished logo that reflects your brand.',
    )),
];

export const normalizeLanguage = (language) => String(language || '').startsWith('en') ? 'en' : 'swe';

function routePath(pathname) {
  const path = String(pathname || '/').split(/[?#]/)[0];
  const withoutLanguage = path.replace(/^\/en(?=\/|$)/, '') || '/';
  return withoutLanguage.replace(/\/+$/, '') || '/';
}

export function findPage(pathname) {
  const path = routePath(pathname);
  return pages.find((page) => page.paths.swe === path || page.paths.en === path);
}

export function languagePath(pageOrPath, language) {
  const lang = normalizeLanguage(language);
  const inputPath = typeof pageOrPath === 'string' ? pageOrPath : '';
  const suffixIndex = inputPath.search(/[?#]/);
  const suffix = suffixIndex >= 0 ? inputPath.slice(suffixIndex) : '';
  const page = typeof pageOrPath === 'string' ? findPage(pageOrPath) : pageOrPath;
  const path = page?.paths?.[lang] || routePath(inputPath);
  return `${lang === 'en' ? '/en' : ''}${path === '/' && lang === 'en' ? '' : path}${suffix}`;
}

export function getStaticRoutes() {
  return pages.flatMap((page) => ['swe', 'en'].map((language) => ({
    path: languagePath(page, language), language, pageId: page.id,
  })));
}
